// Der Anrede-Katalog (GET /contactsalutation), einmal gemeinsam statt fünfmal
// einzeln. Die Anrede ist seit 08/2026 die einzige Stelle, an der das
// Geschlecht einer Person erfasst wird — entsprechend taucht sie in jeder
// Maske auf, die eine Person anlegt.
//
// Geliefert werden LABEL als Wert („Herr"), nicht die Katalog-ID: Das Backend
// löst `salutationName` selbst auf (contact.service.resolveRelations), und die
// Ableitung Anrede → Geschlecht braucht ohnehin den Text. Nur die Kontaktakte
// arbeitet historisch mit der ID.

import { useEffect, useState } from "react";
import { katalogLaden } from "../../utils/katalogCache";

export interface AnredeOption {
  id: number;
  salutation: string;
}

export function useAnredeOptionen(): AnredeOption[] {
  const [optionen, setOptionen] = useState<AnredeOption[]>([]);
  useEffect(() => {
    let abgebrochen = false;
    // Geteilt: dieselbe Maske fragt die Anrede an mehreren Stellen ab.
    katalogLaden<Array<{ id: number; salutation?: string | null }>>("contactsalutation")
      .then((rows) => {
        if (abgebrochen) return;
        setOptionen(
          (Array.isArray(rows) ? rows : [])
            .filter((r) => !!r?.salutation?.trim())
            .map((r) => ({ id: r.id, salutation: String(r.salutation).trim() })),
        );
      })
      .catch(() => {
        // Katalog nicht erreichbar: leere Liste. Das Feld bleibt bedienbar,
        // nur ohne Vorschläge — kein Grund, die ganze Maske scheitern zu lassen.
      });
    return () => {
      abgebrochen = true;
    };
  }, []);
  return optionen;
}
